export enum Roles {
    All = 'all',
    BLOCK_MANAGER_MARKETING = 'block-manager-marketing',
    DISTRICT_MANAGER_MARKETING = 'district-manager-marketing',
    CLF_BOOKKEEPER = 'Institutional Building:CLF Bookkeeper',
    DISTRICT_PE_MANAGER = 'district-pe-manager',
    NATIONAL_MANAGER_MARKETING = 'national-manager-marketing',
    SHG_BOOKKEEPER = 'Institutional Building:SHG Bookkeeper',
    STATE_MANAGER_MARKETING = 'state-manager-marketing',
    UDYOG_MITRA = 'Livelihood Farm:Udyog Mitra',
    VO_BOOKKEEPER = 'Institutional Building:VO Bookkeeper',
    BCIB = 'block-cadre-ib',
    BCF = 'block-cadre-farm',
    BCNF = 'block-cadre-nonfarm',
}
